import { createFileRoute, redirect } from '@tanstack/react-router';

/** Redirect permanente: /originacao (rota antiga) → /pipeline/originacao (Bloco 1, DEC-060). */
export const Route = createFileRoute('/originacao')({
  beforeLoad: () => {
    throw redirect({ to: '/pipeline/originacao' });
  },
});
